import { HttpInterceptorFn } from '@angular/common/http';

const MUTATING = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

function readCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
  return m ? decodeURIComponent(m[1]) : null;
}

/**
 * Double-submit CSRF: the API sets a readable `wiz_csrf` cookie; echo it back in
 * an X-CSRF-TOKEN header on every state-changing request so the API can confirm
 * the call came from our own page and not a cross-site form.
 */
export const csrfInterceptor: HttpInterceptorFn = (req, next) => {
  if (!MUTATING.has(req.method.toUpperCase()) || req.headers.has('X-CSRF-TOKEN')) {
    return next(req);
  }
  const token = readCookie('wiz_csrf');
  return token ? next(req.clone({ setHeaders: { 'X-CSRF-TOKEN': token } })) : next(req);
};
